import { render, staticRenderFns } from "./CustomNav.vue?vue&type=template&id=72b4080a"
import script from "./CustomNav.vue?vue&type=script&lang=js"
export * from "./CustomNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports